var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_check_1807540_000000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.4088 0.000474079C10.1081 0.00827616 9.82323 0.126725 9.61297 0.329578C7.78081 2.05737 6.10844 3.75117 4.34943 5.442L2.28133 3.88158C2.04166 3.70071 1.73568 3.61702 1.43044 3.64895C1.12446 3.68086 0.845605 3.82556 0.65342 4.05182C0.461989 4.27738 0.373062 4.56533 0.406981 4.8526C0.440895 5.14056 0.594643 5.40299 0.834299 5.58386L3.72836 7.76276C4.19111 8.10887 4.85585 8.0727 5.27187 7.67764C7.35347 5.71446 9.21879 3.78577 11.2529 1.86725C11.5928 1.55304 11.6938 1.07499 11.5077 0.662904C11.3208 0.250112 10.8851 -0.012336 10.4088 0.000446843V0.000474079Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5e37d01aae0338e6b8647f111f9fd983.svg";
export { ForwardRef as ReactComponent };